import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Progress extends React.Component {
  onClickHome = () => {
    this.props.setCorrectData({ correctDataState: 'changed' });
    this.props.setForm({ form: 'userForm' });
  }

  onClickUpdate = () => {
    this.props.getTokenSt(this.props.token);
  }

  renderStatusMessage(tokenState) {
    if (tokenState === 'Sincronizzazione non riuscita') {
      return (<div><h1 className="display-1 text-danger"><FontAwesomeIcon icon="exclamation-triangle" /></h1>
      <p className="card-text">{ tokenState }</p></div>);
    }
    if (tokenState === 'Sincronizzazione eseguita con successo') {
      return (<div><h1 className="display-1 text-success"><FontAwesomeIcon icon="check-circle" /></h1>
      <p className="card-text">{ tokenState }</p></div>);
    }
    if (tokenState === 'Sincronizzazione in fase di esecuzione') {
      return (<div><h1 className="display-1"><FontAwesomeIcon icon="spinner" /></h1>
      <p className="card-text">{ tokenState }</p></div>);
    } return null;
  }

  render() {
    const { tokenStState, tokenState} = this.props;
    return <div className="col-12">
  <div className="card text-center">
  <div className="card-header">
  Rhx imapSync
  </div>
  <div className="card-body">
  <h5 className="card-title">Stato attuale</h5>
   {this.renderStatusMessage(tokenState)}
  <div className='row justify-content-center mt-1'>
  <button type="button" className="btn btn-dark col-2" onClick={this.onClickHome}><FontAwesomeIcon icon="home" /> Torna sulla Home</button>
  <button type="button" className="btn btn-dark col-2 offset-2" onClick={this.onClickUpdate} disabled={ tokenStState === 'requested'} ><FontAwesomeIcon icon="hourglass-half" /> Aggiorna stato</button>
  </div>
  </div>
  <div className="card-footer text-muted">
  Rhx
  </div>
  </div>
  </div>;
  }
}
